import { getABTProvider } from '@/plugins/abt/statsig'

export const MERCHANT_BUSINESS_ADDRESS_V2_FLAG =
  'gate_temp_merchant_business_address_v2'

export const ADDRESS_COLLECTION_PATH_V1 = '/address-collection/view'
export const ADDRESS_COLLECTION_PATH_V2 = '/v2/business-address'

export function isMerchantBusinessAddressV2Enabled() {
  return getABTProvider().isFeatureEnabled(MERCHANT_BUSINESS_ADDRESS_V2_FLAG)
}

export function getAddressCollectionPath() {
  return isMerchantBusinessAddressV2Enabled()
    ? ADDRESS_COLLECTION_PATH_V2
    : ADDRESS_COLLECTION_PATH_V1
}

/** V2 lives outside the hash router — use full-page navigation when the flag is on. */
export function redirectToAddressCollectionPath(to = {}) {
  const query = to.query || {}
  const queryString =
    Object.keys(query).length > 0
      ? '?' + new URLSearchParams(query).toString()
      : ''

  window.location.replace(
    window.location.origin + ADDRESS_COLLECTION_PATH_V2 + queryString
  )
}
